export const MOBILE_SEARCH_TRANSITION_MS = 300;
// Keep Tailwind classes in sync with the ms value above.
export const MOBILE_SEARCH_TRANSITION_CLASS = "duration-300";

// Small buffer so layout changes happen after the collapse animation ends.
export const MOBILE_TITLE_RETURN_DELAY_MS = MOBILE_SEARCH_TRANSITION_MS + 20;

